import { render, staticRenderFns } from "./ElementPropertiesPanel.vue?vue&type=template&id=c2d30970&"
import script from "./ElementPropertiesPanel.vue?vue&type=script&lang=ts&"
export * from "./ElementPropertiesPanel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports